import { createSlice } from '@reduxjs/toolkit';

const intialState = {
    value: null,
}

const dataSlice1 = createSlice({
    name:'data',
    initialState: intialState,
    reducers: {
        active: (state, action) => {
            state.value = action.payload;
        },
        notActive: (state) => {
            state.value = null;
        }
    },
})

export const { active,notActive } = dataSlice1.actions

export default dataSlice1.reducer